import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { UpdateProfessionnelTirage } from '../model/tirage/update-professionnel-tirage';
import { ProfessionnelTirage } from '../model/tirage/professionnel-tirage';
import { CreateProfessionnelTirage } from '../model/tirage/create-professionnel-tirage';

@Injectable({
    providedIn: 'root'
  })
  export class ProfessionnelTirageService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    findAllByFacilite(faciliteId) 
    {
        return this._restClientService.load<ProfessionnelTirage[]>('professionnel-tirage/find-all-by-facilite?faciliteId='+faciliteId);
    }
    
    findById(id) 
    {
        return this._restClientService.load<ProfessionnelTirage>('professionnel-tirage/find-by-id/'+id);
    }
    
    update(update: UpdateProfessionnelTirage ) 
    {
        return  this._restClientService.put<UpdateProfessionnelTirage>('professionnel-tirage/update', update);
    }
    
    add(create: CreateProfessionnelTirage) 
    {
        return  this._restClientService.save<UpdateProfessionnelTirage>('professionnel-tirage/add', create);
    }
    
    delete(id) {
      return this._restClientService.delete<any>('professionnel-tirage/delete/'+id);
    }

  


}      

    